import React from 'react'
import "./Air.css"

const Air = () => {
    return (
        <div className="air">
            <h3 className="air-h3">Air freight</h3>
            <p className="p-air">
                940 air cargo is a Freight Forwarder capable of handling your time-sensitive cargo. 
                We forward Air shipments to every Corner of the globe on a daily basis, ranging from fresh produce to 
                Europe and Americas to Project Equipments to Mining and Power Companies in the Great lakes region.
                In addition we avail Cargo capacity daily to world destinations through signing block space 
                Agreements with scheduled cargo/passenger carriers to ensure that our solutions to clients are seamless.
            </p>
        </div>
    )
}

export default Air